<mat-select [(ngModel)]="aspectRatio" name="playout-aspectRatio" class="aspect-ratio-picker" (ngModelChange)="onChange()">
	<mat-select-trigger *ngIf="aspectRatioService.aspectRatioRef[aspectRatio]" class="aspect-ratio-option">
		<ng-container *ngTemplateOutlet="arOption; context: {aspect: aspectRatioService.aspectRatioRef[aspectRatio]}"></ng-container>
	</mat-select-trigger>
	<mat-select-trigger *ngIf="defaultOption && !aspectRatio" class="aspect-ratio-option">
		<ng-container *ngTemplateOutlet="arOption; context: {
			aspect: {
				label: defaultOption,
				subLabel: defaultOptionSublabel || '',
				value: ''
			}
		}"></ng-container>
	</mat-select-trigger>
		
	<mat-option value="" class="aspect-ratio-option" *ngIf="defaultOption">
		<ng-container *ngTemplateOutlet="arOption; context: {
			aspect: {
				label: defaultOption,
				subLabel: defaultOptionSublabel || '',
				value: ''
			}
		}"></ng-container>
	</mat-option>
	<mat-option *ngFor="let aspect of availableOptions" [value]="aspect[valueProp]" class="aspect-ratio-option">
		<ng-container *ngTemplateOutlet="arOption; context: {aspect}"></ng-container>
	</mat-option>
</mat-select>

<ng-template #arOption let-aspect="aspect">
	<div class="image-option">
		<div class="image-wrapper">
			<!-- note: > / <= 2.5 because container is size 50x20 -->
			<div class="ar" [style.aspect-ratio]="aspect.aspectratio || (16 / 9)" [class.fill-width]="aspect.aspectratio > 2.5" [class.fill-height]="!aspect.aspectratio || (aspect.aspectratio <= 2.5)">
				<svg class="default-option" *ngIf="defaultOption && !aspect.value" width="35" height="14" viewBox="0 0 35 14" fill="none" xmlns="http://www.w3.org/2000/svg">
					<line x1="0.5" y1="2.18556e-08" x2="0.5" y2="4" stroke="white"/>
					<line y1="0.5" x2="4" y2="0.5" stroke="white"/>
					<line x1="2.18556e-08" y1="13.5" x2="4" y2="13.5" stroke="white"/>
					<line x1="0.5" y1="14" x2="0.5" y2="10" stroke="white"/>
					<line x1="34.5" y1="14" x2="34.5" y2="10" stroke="white"/>
					<line x1="35" y1="13.5" x2="31" y2="13.5" stroke="white"/>
					<line x1="35" y1="0.5" x2="31" y2="0.5" stroke="white"/>
					<line x1="34.5" x2="34.5" y2="4" stroke="white"/>
				</svg>
				<svg width="5" height="6" viewBox="0 0 5 6" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M0.950521 0.0945057C0.757812 -0.0273478 0.515625 -0.0313649 0.31901 0.0824542C0.122396 0.196273 0 0.410521 0 0.643516V5.35697C0 5.58996 0.122396 5.80421 0.31901 5.91803C0.515625 6.03185 0.757812 6.02649 0.950521 5.90598L4.70052 3.54925C4.88672 3.43275 5 3.2252 5 3.00024C5 2.77528 4.88672 2.56907 4.70052 2.45123L0.950521 0.0945057Z" fill="white"/>
				</svg>
			</div>
		</div>
		<span>
			{{ aspect.label }}
		</span>
		<span class="sub-label" *ngIf="aspect.subLabel || aspect.aspectwidth">
			{{ aspect.subLabel ? aspect.subLabel : aspect.aspectwidth + ' / ' + aspect.aspectheight }}
		</span>
	</div>
</ng-template>
